import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export enum ELeadPaymentStatus {
    Pending = 0,
    Paid = 1,
    Cancelled = 2,
    Refunded = 3,
}

export interface PaymentProvider {
    provider: string;
    name: string;
}

/// Para o bloco de cobranças mostrar de onde veio um link mesmo com aquele meio já desligado.
export const PROVIDER_NAME: Record<string, string> = {
    'mercado-pago': 'Mercado Pago',
    asaas: 'Asaas',
    stripe: 'Stripe',
};

export interface LeadPayment {
    id: string;
    provider: string;
    amount: number;
    description: string;
    checkoutUrl: string;
    status: ELeadPaymentStatus;
    paidAmount?: number | null;
    paidAt?: string | null;
    createdAt: string;
    createdByName?: string | null;
}

export class LeadPaymentService extends BaseService {
    protected get resourceName(): string {
        return 'crm';
    }

    public async providers(): Promise<AxiosResponse<{ data: PaymentProvider[] }>> {
        return await this.get('payments/providers');
    }

    public async list(leadId: string): Promise<AxiosResponse<{ data: LeadPayment[] }>> {
        return await this.get(`leads/${leadId}/payments`);
    }

    public async create(
        leadId: string,
        body: { provider: string | null; amount: number; description: string },
    ): Promise<AxiosResponse<{ data: LeadPayment }>> {
        return await this.post(body, `leads/${leadId}/payments`);
    }
}
